/*
 * ---------------------------------------------
 * Author: Jan de Lemos
 * Date:   Thursday February 5th 2026
 * Last Modified by: Jan de Lemos - <jan.delemos@mwell.com.ph>
 * Last Modified time: February 11th 2026, 10:41:19 am
 * Copyright (c) 2026 MWELL
 * ---------------------------------------------
 */

import { Doctor } from "types";
import { getDoctorImage, replaceWithAmpersand } from "helpers";

const transformDoctor = (data: any, isCounselorFromQuery?: boolean): Doctor => {
  const {
    id,
    givenName,
    familyName,
    photo,
    yearsExperience,
    price,
    specialisations,
    isMwellPlus,
    isCounselor: isCounselorFromApi,
  } = data;

  const isCounselor =
    typeof isCounselorFromQuery === "boolean"
      ? isCounselorFromQuery
      : Boolean(isCounselorFromApi);

  return {
    id,
    firstName: givenName,
    lastName: familyName,
    displayName: isCounselor
      ? `${familyName}, ${givenName}`
      : `Dr. ${familyName}, ${givenName}`,
    image: photo && getDoctorImage(id, photo),
    experience: yearsExperience,
    price,
    specialties: specialisations,
    specialtiesJoined: replaceWithAmpersand(specialisations.join(", ")),
    isPremium: isMwellPlus,
  };
};

export { transformDoctor };
